import { render } from "./403.vue?vue&type=template&id=0a8c4780&scoped=true"
const script = {}

import "./403.vue?vue&type=style&index=0&id=0a8c4780&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a8c4780"

export default script